{
    "page_title": "Team",
    "page_sub_title": "Activity and coverage of your team members with a Plato account. Reps without a Plato account are not listed here. Click or hover on a value to see more.",
    "stats_revenue": "Team Revenue & GM",
    "stats_revenue_tooltip": "Billed revenue across the customers of the users shown below, in the selected period. The footer shows the gross-margin rate.",
    "stats_margin_label": "gross margin",
    "stats_churn": "Open Risks",
    "stats_churn_tooltip": "Open value of churn warnings across the visible customers. Each warning is revenue that can be lost if the customer is not re-engaged. Does not follow the selected period.",
    "stats_churn_footer": "{{value}} warnings",
    "stats_opportunity": "Open Opportunity",
    "stats_opportunity_tooltip": "Open value of opportunities across the visible customers, such as cross-sell and assortment expansion. Does not follow the selected period.",
    "stats_opportunity_footer": "{{value}} opportunities",
    "user_table__column_user": "User",
    "user_table__column_customer_coverage": "Customer Coverage",
    "user_table__column_revenue_coverage": "Revenue Coverage",
    "user_table__tooltip_customer_coverage": "Share of assigned customers where the user logged a visit themselves in the last 12 months. Meetings that were only planned, without a log, don't count, nor do visits marked “not reached”, calls, or logs by others. Does not follow the selected period.",
    "user_table__tooltip_revenue_coverage": "Share of assigned customer revenue that comes from customers with a visit logged by the user, both over the last 12 months. Meetings that were only planned, without a log, and visits marked “not reached” don't count. Does not follow the selected period.",
    "user_table__column_new_task": "New Task",
    "all_regions": "All Regions",
    "no_region": "No region",
    "sales_region_label": "Sales Region",
    "search_placeholder_users": "Search by user",
    "user_table__breakdown_total": "Total",
    "user_table__column_contacts": "Logged Interactions",
    "user_table__tooltip_contacts": "Customer interactions the user logged in the selected period - visits, calls, notes. Breakdown and note quality on hover.",
    "user_table__interaction_visits": "Visits",
    "user_table__interaction_phone_calls": "Phone calls",
    "user_table__interaction_notes": "Notes",
    "user_table__visits_per_week": "Visits / Week",
    "user_table__visits_documented_planned": "Documented / planned visits",
    "user_table__note_depth": "Quality · Notes with content",
    "user_table__open_activities": "All activities",
    "user_table__column_recommendations": "Processed AI Recommendations",
    "user_table__tooltip_recommendations": "How the user interacted with AI recommendations in the selected period - discussed or marked not relevant. Breakdown by outcome on hover.",
    "user_table__recommendations_discussed": "Discussed",
    "user_table__recommendations_interested": "Interested",
    "user_table__recommendations_no_need": "No need",
    "user_table__recommendations_buys_elsewhere": "Buys elsewhere",
    "user_table__recommendations_not_relevant": "Irrelevant",
    "user_table__recommendations_incorrect": "Incorrect merchandise group",
    "user_table__recommendations_normal": "Normal behavior",
    "user_table__column_revenue": "Revenue",
    "user_table__tooltip_revenue": "Billed revenue across the user's assigned customers in the selected period, with the change vs. the same period last year.",
    "user_table__column_gross_margin": "GM",
    "user_table__tooltip_gross_margin": "Gross margin (€) across the user's assigned customers in the selected period, with the change vs. the same period last year.",
    "user_table__column_gm_percent": "GM %",
    "user_table__tooltip_gm_percent": "Gross-margin rate (margin ÷ revenue) in the selected period, with the change vs. the same period last year in percentage points.",
    "user_table__column_plato_revenue": "AI Revenue",
    "user_table__tooltip_plato_revenue": "Billed revenue generated after a rep marked an AI recommendation from Plato as “Interested”. We count only orders dated within the selected period - the recommendation itself may be older than the period.",
    "user_table__plato_revenue_recommendations": "AI recommendations",
    "user_table__plato_revenue_share": "Share of revenue",
    "user_table__column_churn_risk": "Open Risks",
    "user_table__tooltip_churn_risk": "Open value of churn warnings among the user's assigned customers. Does not follow the selected period.",
    "user_table__churn_risk_count": "Open warnings",
    "user_table__churn_risk_customers": "Affected customers",
    "user_table__column_opportunities": "Open Opportunities",
    "user_table__tooltip_opportunities": "Open value of opportunities among the user's assigned customers. Does not follow the selected period.",
    "user_table__opportunities_count": "Open opportunities",
    "user_table__opportunities_customers": "Customers with opportunities",
    "user_table__inactive": "Inactive",
    "user_table__inactive_tooltip": "No activity in Plato this period - no visits, calls or notes, no recommendations handled, no tasks completed. Inactive despite having assigned customers.",
    "user_table__churn_risk_flag": "High revenue at risk",
    "user_table__churn_risk_flag_tooltip": "The open churn-warning value on this user's customers stands out vs. the team, measured against their own assigned revenue.",
    "user_table__column_tasks": "Tasks",
    "user_table__tooltip_tasks": "Tasks currently open and assigned to the user, with overdue and period-completed counts on hover. Does not follow the selected period.",
    "user_table__tasks_open": "{{value}} open",
    "user_table__tasks_completed": "{{value}} done",
    "user_table__tasks_row_open": "Open",
    "user_table__tasks_row_overdue": "Overdue",
    "user_table__tasks_row_completed": "Completed in period",
    "plato_revenue_total": "Revenue from AI Recommendations",
    "tooltip_plato_revenue_total": "Billed revenue generated after reps marked AI recommendations from Plato as “Interested”.",
    "plato_revenue_total_footer": "from {{value}} tracked recommendations",
    "plato_revenue_total_share_label": "of revenue",
    "user_table__role_manager": "Manager",
    "user_table__role_super_manager": "Super Manager",
    "user_table__role_customer_service_rep": "Customer Service",
    "user_table__role_inside_sales_rep": "Inside Sales",
    "user_table__role_outside_sales_rep": "Outside Sales",
    "user_table__role_other": "Other",
    "all_roles": "All Roles",
    "role_label": "Role"
}
